import { CURRENT_USER_TAG, FEATURES_BETA_TAG } from '../constants/invalidate';

import type { QueryClient } from '@zg-rentals/react-query5';
import type {
  FeaturesBetaDetailsResponseDto,
  RentalManagerAuthCheckUserInfoWebApiDto,
} from '@zg-rentals/ts-rental-manager-api-client';

// The auth layer caches the user's roles for about a second, so a refetch right after enroll or
// unenroll still returns the old status. Write the new status now and refetch once that has passed.
const AUTH_CACHE_SETTLE_MS = 2_000;

const hasTag =
  (tag: string) =>
  ({ meta }: { meta?: { tags?: Array<string> } }) =>
    Boolean(meta?.tags?.includes(tag));

let settleTimer: ReturnType<typeof setTimeout> | undefined;

export const setFeaturesBetaMembership = (queryClient: QueryClient, isBetaUser: boolean) => {
  queryClient.setQueriesData<RentalManagerAuthCheckUserInfoWebApiDto>(
    { predicate: hasTag(CURRENT_USER_TAG) },
    (cached) => cached && { ...cached, isFeaturesBeta: isBetaUser },
  );
  queryClient.setQueriesData<FeaturesBetaDetailsResponseDto>(
    { predicate: hasTag(FEATURES_BETA_TAG) },
    (cached) => cached && { ...cached, isBetaUser, ...(isBetaUser && { canSelfEnroll: false }) },
  );

  clearTimeout(settleTimer);
  settleTimer = setTimeout(() => {
    void queryClient.invalidateQueries({
      predicate: (query) => hasTag(CURRENT_USER_TAG)(query) || hasTag(FEATURES_BETA_TAG)(query),
    });
  }, AUTH_CACHE_SETTLE_MS);
};
